import { useAuth0 } from "@auth0/auth0-react";
import { Container } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Button from "@/components/Button";

export default function Logout() {
  const { logout } = useAuth0();
  const history = useHistory();

  const handleLogout = async () => {
    await logout({
      logoutParams: {
        returnTo: "https://www.google.com/",
      },
    });
    history.push("/login");
  };

  return (
    <Container className="page-container">
      <h1>Logout</h1>
      <Button onClick={handleLogout}>Logout</Button>
    </Container>
  );
}
